import { SagaIterator } from 'redux-saga';
import { takeEvery } from 'redux-saga/effects';
import { DeleteCollection } from '../../../actions/AppActionTypes';
import { deleteCollection } from './DeleteContentsSaga';

export function* rootCollectionSaga(): SagaIterator {
  yield takeEvery(DeleteCollection, deleteCollection);
}
